// extracted by mini-css-extract-plugin
var _1 = "Arrows_arrows__21ba4";
var _2 = "Arrows_icon__30f44";
var _3 = "Arrows_isV2__bbc4b";
export { _1 as "arrows", _2 as "icon", _3 as "isV2" }
